<template>
  <div style="height: 200px; width: 100%;" class="pr-2 pb-2">
    <v-card class="d-flex fill-height" :to="nr===undefined ? undefined : `/dashboard/${isodate}/${nr}`" style="overflow: hidden;">
      <v-card-text style="position: relative;" class="align-self-stretch">
        <!--    -->
        <v-row v-if="loading" style="position: absolute; left: 12px; top:0px; width: 100%; height: 100%;" justify="center" align="center">
          <v-progress-circular indeterminate color="accent" size="64"/>
        </v-row>
        <v-row v-else style="position: absolute; left: 12px; top:0px; bottom: 0; right: 12px" >
          <v-col :cols="12" class="d-flex flex-column justify-space-between" style="position: relative">
            <div :style="`position: absolute; left: -130px; top:0; width: 200px; height: 300px; background-color: ${color}; transform: rotate(-20deg); z-index:0;`" ></div>
            <h6 class="body-1 mt-0 text-no-wrap text-truncate text-center">{{ bereichName }}</h6>
            <v-row class="justify-space-around pt-4 mr-0 ml-0">
              <div style="position: relative; font-size: 90px; height: 100px;" class="font-weight-light">
                <div class="mt-8">
                  {{index ? Math.round(index) : 0}}
                </div>
                <div style="position: absolute; right: -20px; top:0; font-size: 30px; margin-top: 0">
                  <v-icon v-if="lastWeekIndex" :color="indexTrendColor">
                    {{indexTrendIcon}}
                  </v-icon>
                </div>
                <div style="position: absolute; right: -50px; bottom:20px; width: 50px; margin-top: 0;" >
                  <span class="ml-0 grey--text body-2">(⌀ {{ activityAvg(bereich) }})</span>
                </div>
              </div>
            </v-row>
            <medal :type="medalType" style="position: absolute; right: 12px; top:60px; width: 80px; height: 70px;"></medal>
            <v-row class="mx-3 mb-3" style="background-color: #ebebeb; height: 10px;z-index: 1; border: 2px solid white;">
              <div class="d-flex" :style="'background-color: '+color+'; flex-grow: '+((index||0)/100)"></div>
              <div class="d-flex" style=""></div>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import Rocket from "@/components/Rocket";
const {DateTime} = require("luxon");
import {round} from "@/reusable/numbers";
import Bereiche from "@/components/Bereiche";
import Kinds from "@/components/Kinds";
import Activity from "@/components/Activity";
import {Badge} from "@/components/Badge";
import Medal from "@/components/Medal";

export default {
  name: "BereichWeek",
  components: {Medal, Rocket,},
  props: ['bereich', 'date', 'index', 'loading', 'nr', 'lastWeekIndex', 'activityTotals'],
  data() {
    return {
      weekDate:undefined,
      //badge:undefined,
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      var dateTime=DateTime.local();
      if (this.date)
        dateTime=DateTime.fromJSDate(this.date);
      this.weekDate=dateTime.setLocale("de").startOf("week");
      //await this.loadBadge();
    },
    // async loadBadge() {
    //   var id = Badge.makeId(this.weekDate.toISODate(), this.bereich);
    //   this.badge=(await this.$backend.get_object(Kinds.KIND_BADGE, id)) || {};
    //   console.log("Badge: ", this.badge);
    // },
    getTextStyle(bereich) {
      return { 'color':Bereiche.COLORS_BY_NAME[this.bereich]};
    },
    activityAvg(bid) {
      var totals=(this.activityTotals || {}).allTimeTotals || {};
      var Ns=(this.activityTotals || {}).allTimeNs || {};
      var total=totals[bid] || 0;
      var n = Ns[bid] || 0;
      if (n===0)
        return 0;
      return Math.round(total / n, 0);
    },
  },
  computed: {
    isodate(){
      return DateTime.fromJSDate(this.date).setLocale("de").toISODate();
    },
    color() {
      return Bereiche.COLORS_BY_NAME[this.bereich];
    },
    bereiche(){
      return Bereiche.NAMES;
    },
    bereichName() {
      return this.$app.getBereichName(this.bereich);
    },
    medalType() {
      if (this.index >= 100)
        return "gold";
      if (this.index >= 90)
        return "silver";
      if (this.index >= 75)
        return "bronze";
      return "none";
    },
    indexTrendIcon() {
      if (!this.lastWeekIndex)
        return "";
      var last=this.lastWeekIndex[this.bereich];
      if (last < (this.index || 0))
        return 'mdi-arrow-up-circle';
      if (last > (this.index || 0))
        return 'mdi-arrow-down-circle';
      return 'mdi-checkbox-marked-circle';
    },
    indexTrendColor() {
      if (!this.lastWeekIndex)
        return "";
      var last=this.lastWeekIndex[this.bereich];
      if (last < (this.index || 0))
        return 'green lighten-1';
      if (last > (this.index || 0))
        return 'red lighten-1';
      return 'green lighten-1';
    },
  },
  watch: {

  }
}
</script>

<style scoped>

</style>